import { createSlice, createAsyncThunk,PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import fetchAPI from "../../common/fetchAPI";
import { sortData } from "../../common/timeLiveFunction";
interface auditStateClass {
    isLoading: boolean;
    status: 'idle' | 'loading' | 'failed';
    accountAuditList: Array<any>;
    expenseAuditList: Array<any>;
    timeEntryAuditList: Array<any>;
    employeeTimeEntryList: Array<any>;
    selectedRecord: any;
    isReload: boolean;
    sortOrder: string;
    sortColumn: string;
    search: string;
    pageNo: number;
    pageSize: number;
    auditPageNo: number;
    auditPageSize: number;
    auditSearch: string;
}

const initialState: auditStateClass = {
    isLoading: false,
    status: 'idle',
    accountAuditList: [],
    expenseAuditList:[],
    timeEntryAuditList:[],
    employeeTimeEntryList:[],
    selectedRecord: {},
    isReload: false,
    sortOrder: 'asc',
    sortColumn: 'FieldName',
    search: '',
    pageNo: 1,
    pageSize: 10,
    auditPageNo: 1,
    auditPageSize: 10,
    auditSearch: ''
}

interface IThunkApi {
    state: {
        audit: auditStateClass
    }
}

export const getAuditAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'audit/getAudit',
        async (arg, thunkApi) => {
            const response = await fetchAPI( `api/V2/Audit/GetAuditRecords?TableName=${arg.TableName}&Id=${arg.Id || ''}&SelectedColumns=${''}&WhereClause=${''}`, 'Get', '', true, '');
            const json = await response.json();
            return json
        }

    )


 export const getAuditExpenseEntriesAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'audit/getAuditExpenseEntries',
        async (arg, thunkApi) => {
            const response = await fetchAPI( `api/V2/Audit/GetAuditRecords?TableName=${arg.TableName}&Id=${arg.Id || ''}&SelectedColumns=${''}&WhereClause=${''}`, 'Get', '', true, '');
            const json = await response.json();
            return json
        }
    )

    
    export const getAccountEmployeeTimeEntryDetailsAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'audit/getAccountEmployeeTimeEntryDetails',
        async (arg, thunkApi) => {
            const response = await fetchAPI( 'api/v2/Timesheets/GetAccountEmployeeTimeEntryDetails/' + arg , 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json
        }
    )

    export const getAuditTimeEntriesAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'audit/getAuditTimeEntries',
        async (arg, thunkApi) => {
            const response = await fetchAPI( `api/V2/Audit/GetAuditRecords?TableName=${arg.TableName}&Id=${arg.Id || ''}&SelectedColumns=${''}&WhereClause=${''}`, 'Get', '', true, '');
            const json = await response.json();
            return json
        }
    )


export const auditSlice = createSlice({
    name: 'audit',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        resetAuditList:(state)=>{
            state.accountAuditList = [];
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateAuditPagination: (state, action: PayloadAction<any>) => {
            state.auditPageSize = action.payload.auditPageSize;
            state.auditPageNo = action.payload.auditPageNo;
            state.auditSearch = action.payload.auditSearch;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.accountAuditList;
            state.accountAuditList = sortData(Object.values(tempArray), action.payload.sortOrder, action.payload.sortColumn);
        }
    },
    extraReducers: (builder) => {
        builder           
            .addCase(getAuditAsync.pending, state => {
                state.accountAuditList = [];
                state.status = 'loading';
                state.isLoading = true;
            }).addCase(getAuditAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.accountAuditList =payload.Data;
                state.isReload = false;
                state.isLoading = false;
            }).addCase(getAuditAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })  
            
            
            .addCase(getAuditExpenseEntriesAsync.pending, state => {
                state.expenseAuditList = [];
                state.status = 'loading';
            }).addCase(getAuditExpenseEntriesAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.expenseAuditList =payload.Data;
                state.isReload = false;
            }).addCase(getAuditExpenseEntriesAsync.rejected, (state) => {
                state.status = 'failed';
            })  

            .addCase(getAccountEmployeeTimeEntryDetailsAsync.pending, state => {
                state.employeeTimeEntryList = [];
                state.status = 'loading';
                state.isLoading = true;
            }).addCase(getAccountEmployeeTimeEntryDetailsAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.employeeTimeEntryList = payload.AccountEmployeeTimeEntry;
                state.isReload = false;
                state.isLoading = false;
            }).addCase(getAccountEmployeeTimeEntryDetailsAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })

            .addCase(getAuditTimeEntriesAsync.pending, state => {
                state.timeEntryAuditList = [];
                state.status = 'loading';
            }).addCase(getAuditTimeEntriesAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.timeEntryAuditList = payload.Data;
                state.isReload = false;
            }).addCase(getAuditTimeEntriesAsync.rejected, (state) => {
                state.status = 'failed';
            })  
    }
})

export const { resetSelectedRecordObjectInState, resetAuditList,updatePagination,updateSorting, updateAuditPagination } = auditSlice.actions;
export const auditState = (state: RootState) => state.audit
export default auditSlice.reducer;